export default
function pressurePoint(state = {}, action){
  switch(action.type) {
    case 'TOGGLE_PRESSURE_POINT':
      return Object.assign({}, state, {
        currentPP: action.currentPP,
        nodeRect: action.nodeRect
      });
    case 'RESET_PRESSURE_POINT':
      return Object.assign({}, state, {
        currentPP: null,
        nodeRect: null
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/pressurePoint.js